import {Flex, Spin} from 'antd';
import React from 'react';

const Loader: React.FC<{isHome?: boolean; topMargin?: boolean}> = ({
  isHome = false,
  topMargin = false
}) => {
  return (
    <Flex
      align="center"
      gap="middle"
      justify="center"
      className={`loader ${
        isHome ? 'fullScreen' : topMargin ? 'topMargin' : ''
      }`}
    >
      <Spin size="large" />
    </Flex>
  );
};

export default Loader;
